import { render, staticRenderFns } from "./doctorspecialty.vue?vue&type=template&id=5d5a7e07"
import script from "./doctorspecialty.vue?vue&type=script&lang=js"
export * from "./doctorspecialty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports